import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface Props {
  markdown: string;
  className?: string;
}

const BASE_PROSE_CLASSES =
  "prose dark:prose-invert prose-sm text-ink dark:text-ink-dark " +
  "prose-p:my-2 prose-p:leading-relaxed " +
  "prose-headings:my-3 prose-headings:font-semibold " +
  "prose-ul:my-2 prose-ol:my-2 prose-li:my-0.5 " +
  "prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:bg-canvas dark:prose-code:bg-canvas-dark " +
  "prose-code:before:content-none prose-code:after:content-none " +
  "prose-pre:bg-canvas dark:prose-pre:bg-canvas-dark prose-pre:text-ink dark:prose-pre:text-ink-dark prose-pre:overflow-x-auto " +
  "prose-strong:text-ink dark:prose-strong:text-ink-dark prose-strong:font-semibold " +
  "prose-a:text-chip-orange prose-a:no-underline hover:prose-a:underline " +
  "prose-blockquote:border-l-chip-orange/40 prose-blockquote:not-italic " +
  "prose-table:my-2 prose-table:max-w-full prose-table:overflow-x-auto";

export function AgentMarkdown({ markdown, className }: Props) {
  return (
    <div className={[BASE_PROSE_CLASSES, className].filter(Boolean).join(" ")}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
